import { createI18n } from 'vue-i18n';

const locale = 'no';

const i18n = createI18n({
    locale,
    allowComposition: true,
    globalInjection: true
});

export default i18n;
